import {
  REQUEST_SECURITY_DATA,
  SECURITY_DATA_FAILED,
  SECURITY_DATA_SUCCESS,
} from '../actions/types';

export const securityReducers = (
  state = {
    loading: true,
  },
  action,
) => {
  switch (action.type) {
    case REQUEST_SECURITY_DATA:
      return { loading: true };
    case SECURITY_DATA_SUCCESS:
      return { loading: false, data: action.payload };
    case SECURITY_DATA_FAILED:
      return { loading: false };
    default:
      return state;
  }
};
